export const USER_AUTH_SUCCESS = 'USER_AUTH_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const GET_USER = 'GET_USER';

export const SET_CONFIGURATION = 'SET_CONFIGURATION'


export const CLEAN_CART = 'CLEAN_CART';
export const GET_CART_FROM_STORAGE = 'GET_CART_FROM_STORAGE';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const REMOVE_COD_ARTICU_FROM_CART = 'REMOVE_COD_ARTICU_FROM_CART';
export const EDIT_CART_QUANTITY = 'EDIT_CART_QUANTITY';

export const ATTACH_SHIPMENT_INFO = 'ATTACH_SHIPMENT_INFO';
export const PROCESS_CART_PURCHASE = 'PROCESS_CART_PURCHASE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js